function ToUint32(x) {
  return x >>> 0;
}

function SignExtend16(x) {
  x = ToUint32(x);

  if (x >>> 15 > 0) {
    x |= 0xFFFF0000;
  }

  return x;
}

function IF(latches, registers, memory, globals) {
  var location = registers.read(nameToRegisterMap["$pc"]);

  var byte_1 = memory.read(location);
  var byte_2 = memory.read(location + 1);
  var byte_3 = memory.read(location + 2);
  var byte_4 = memory.read(location + 3);

  var binary = byte_4;
  binary |= byte_3 << 8;
  binary |= byte_2 << 16;
  binary |= byte_1 << 24;
  binary = ToUint32(binary);

  if (binary == 0xFAFAFAFA) {
    latches.term_if = true;
  } else {
    latches.if_id = {
      "binary" : binary,
      // used for forwarding in hazards
      "rs_val" : undefined,
      "rt_val" : undefined
    };
  }
}

function ID(latches, registers, memory, globals) {
  // happens in cases where the instruction was executed in ID stage
  if (latches.if_id === undefined) {
    latches.id_ex = undefined;
    return;
  }

  var fetch = latches.if_id;

  var binary = fetch["binary"];
  var opcode = binary >>> 26;

  var rs, rt, rd;
  var op_str;

  var pc, pc_val, result;
  var instruction;

  var rs_val, rt_val;

  if (opcode == 0x0) {
    rs = binary >>> 21 & 0x1f
    rt = binary >>> 16 & 0x1f
    rd = binary >>> 11 & 0x1f
    var shamt = binary >>> 6 & 0x1f
    var funct = binary & 0x3f

    rs_val = fetch["rs_val"]
    if (rs_val === undefined) {
      rs_val = registers.read(rs);
    }

    op_str = functMap[funct];
    switch(op_str) {
      case 'jr':
        pc = nameToRegisterMap["$pc"];
        position = pc;
        result = ToUint32(rs_val);
        registers.write(position, result)
        break;
      default:
        instruction = {
          "op_str" : op_str,
          "rs" : rs,
          "rt" : rt,
          "rd" : rd,
          "shamt" : shamt
        }
        break;
    }
  }

  else if (opcode == 0x2 || opcode == 0x3) {
    // J format: oooooott ttttttt tttttttt tttttttt
    var target = (binary & 0x3FFFFFF) << 2;

    op_str = opcode == 0x2 ? "j" : "jal";
    position = nameToRegisterMap["$pc"];
    switch(op_str) {
      case 'j':
        pc = nameToRegisterMap["$pc"];
        // Lop off the two top bits
        target &= 0x3FFFFFFF;

        pc_val = ToUint32(registers.read(pc));
        // Keep only the top two bits
        pc_val &= 0xC0000000;

        result = pc_val | target;
        registers.write(position, result)
        break;
      case 'jal':
        pc = nameToRegisterMap["$pc"];
        ra = nameToRegisterMap["$ra"];
        // Lop off the two top bits
        target &= 0x3FFFFFFF;

        pc_val = ToUint32(registers.read(pc));

        result = (pc_val & 0xC0000000) | target;

        registers.write(position, result)
        registers.write(ra, pc_val + 8);
        break;
      default:
        break;
    }
  }

  else {
    // I format: ooooooss sssttttt iiiiiiii iiiiiiii
    rs = (binary >>> 21) & 0x1F;
    rt = (binary >>> 16) & 0x1F;
    var imm = SignExtend16(binary & 0xFFFF);

    rs_val = fetch["rs_val"]
    rt_val = fetch["rt_val"]

    if (rs_val === undefined) {
      rs_val = registers.read(rs);
    }

    if (rt_val === undefined) {
      rt_val = registers.read(rs);
    }

    op_str = opcodeMap[opcode];
    switch(op_str) {
      case 'beq':
        if (rs_val == rt_val) {
          pc = nameToRegisterMap["$pc"];
          var target = imm << 2;

          position = pc;
          result = ToUint32(registers.read(pc) + target + 4);
          registers.write(position, result)
        }

        instruction = undefined;
        break;
      default:
        instruction = {
          "op_str" : op_str,
          "rs" : rs,
          "rt" : rt,
          "imm" : imm
        }
        break;
    }
  }

  latches.id_ex = instruction;

  // used for forwarding in hazards
  if (instruction !== undefined) {
    latches.id_ex["rs_val"] = undefined
    latches.id_ex["rt_val"] = undefined
  }
}

function EX(latches, registers, memory, globals) {
  // happens in cases where the instruction was executed in ID stage
  if (latches.id_ex === undefined) {
    latches.ex_mem = undefined;
    return;
  }

  var instruction = latches.id_ex;

  var rs, rt, rd;
  var rs_val, rt_val;
  var op_str = instruction["op_str"];

  var pc, pc_val, result;
  var ra;

  var r_ops = ['addu', 'subu', 'and', 'or', 'xor', 'sll', 'srl', 'sra'];
  var i_ops = ['addiu', 'andi', 'ori', 'xori'];

  var location, position, result, memory_address;
  var writeInfo;

  if (r_ops.indexOf(op_str) != -1) {
    rs = instruction["rs"]
    rt = instruction["rt"]
    rd = instruction["rd"]
    var shamt = instruction["shamt"]

    location = "registers";
    position = rd;

    rs_val = instruction["rs_val"]
    rt_val = instruction["rt_val"]

    if (rs_val === undefined) {
      rs_val = registers.read(rs);
    }

    if (rt_val === undefined) {
      rt_val = registers.read(rt);
    }

    switch(op_str) {
      case 'addu':
        result = ToUint32(rs_val + rt_val);
        break;
      case 'subu':
        result = ToUint32(rs_val - rt_val);
        break;
      case 'and':
        result = ToUint32(rs_val & rt_val);
        break;
      case 'or':
        result = ToUint32(rs_val | rt_val);
        break;
      case 'nor':
        result = ToUint32(!(registers.read(rs) | registers.read(rt)));
        break;
      case 'xor':
        result = ToUint32(rs_val ^ rt_val);
        break;
      case 'sll':
        result = ToUint32(rs_val << rt_val);
        break;
      case 'srl':
        result = ToUint32(rs_val >>> rt_val);
        break;
      case 'sra':
        result = ToUint32(rs_val >> rt_val);
        break;
      default:
        break;
    }
  }

  else if (i_ops.indexOf(op_str) != -1) {
    // I format: ooooooss sssttttt iiiiiiii iiiiiiii
    rs = instruction["rs"]
    rt = instruction["rt"]
    var imm = instruction["imm"]

    // used in store/load instructions
    memory_address = ToUint32(registers.read(rs)) + ToUint32(imm);
    var byte_1, byte_2, byte_3, byte_4;
    var value;

    rs_val = instruction["rs_val"]

    if (rs_val === undefined) {
      rs_val = registers.read(rs);
    }

    switch(op_str) {
      case 'addiu':
        location = "registers";
        position = rt;
        result = rs_val + SignExtend16(imm);
        break;
      case 'andi':
        location = "registers";
        position = rt;
        result = ToUint32(rs_val & imm);
        break;
      case 'ori':
        location = "registers";
        position = rt;
        result = ToUint32(rs_val | imm);
        break;
      case 'xori':
        location = "registers";
        position = rt;
        result = ToUint32(rs_val ^ imm);
        break;
      default:
        break;
    }
  }

  latches.ex_mem = {
    "instruction": instruction, // for instructions to execute in MEM stage
    "memory_address": memory_address, // only relevant for load/stores
    "result": result,
    "location": location,
    "position": position
  }
}

function MEM(latches, registers, memory, globals) {
  if (latches.ex_mem === undefined) {
    latches.mem_wb = undefined;
    return;
  }

  var instruction = latches.ex_mem["instruction"];
  var memory_address = latches.ex_mem["memory_address"];

  var result = latches.ex_mem["result"];
  var location = latches.ex_mem["location"];
  var position = latches.ex_mem["position"];

  var mem_ops = ['sw', 'sh', 'sb', 'lw', 'lh', 'lb'];

  var rs, rt, rd;
  var op_str = instruction["op_str"];

  var pc, result;

  if (mem_ops.indexOf(op_str) != -1) {
    // I format: ooooooss sssttttt iiiiiiii iiiiiiii
    rs = instruction["rs"]
    rt = instruction["rt"]
    var imm = instruction["imm"]

    // used in store/load instructions
    var byte_1, byte_2, byte_3, byte_4;
    var value;

    switch(op_str) {
      case 'sw':
        value = ToUint32(registers.read(rt));

        byte_1 = (value >>> 24) & 0xFF;
        byte_2 = (value >>> 16) & 0xFF;
        byte_3 = (value >>> 8) & 0xFF;
        byte_4 = value & 0xFF;

        location = "memory";
        position = memory_address;
        result = [byte_1, byte_2, byte_3, byte_4]
        break;
      case 'sh':
        value = ToUint32(registers.read(rt));

        byte_1 = (value >>> 8) & 0xFF;
        byte_2 = value & 0xFF;

        location = "memory";
        position = memory_address;
        result = [byte_1, byte_2]
        break;
      case 'sb':
        value = ToUint32(registers.read(rt));
        byte_1 = value & 0xFF;

        location = "memory";
        position = memory_address;
        result = [byte_1]
        break;
      case 'lw':
        byte_1 = memory.read(memory_address);
        byte_2 = memory.read(memory_address + 1);
        byte_3 = memory.read(memory_address + 2);
        byte_4 = memory.read(memory_address + 3);

        result = byte_4;
        result |= byte_3 << 8;
        result |= byte_2 << 16;
        result |= byte_1 << 24;

        location = "registers";
        position = rt;
        break;
      case 'lh':
        byte_1 = memory.read(memory_address);
        byte_2 = memory.read(memory_address + 1);

        result = byte_2;
        result |= byte_1 << 8;

        location = "registers";
        position = rt;
        break;
      case 'lb':
        byte_1 = memory.read(memory_address);
        result = byte_1;
        location = "registers";
        position = rt;
        break;
      case 'lui':
        result = imm << 16;
        registers.write(rt, result);
        break;
      default:
        break;
    }
  }

  if (location == "memory") {
    for (var i = 0; i < result.length; i++) {
      memory.write(position + i, result[i]);
    }
  }

  latches.mem_wb = {
    "instruction": instruction,
    "result": result,
    "location": location,
    "position": position
  }
}

function WB(latches, registers, memory, globals) {
  if (latches.mem_wb === undefined) {
    return;
  }

  if (latches.mem_wb["location"] == "registers") {
    registers.write(latches.mem_wb["position"], latches.mem_wb["result"])
  }
}

function binaryDependencies(binary) {
  var dependencies = {
    "read": new Map(),
    "write": new Map()
  };

  var op_str;
  var rs;
  if (binary != undefined) {
    var opcode = binary >>> 26;
    if (opcode == 0x0) {
      var funct = binary & 0x3f
      op_str = functMap[funct];
      rs = binary >>> 21 & 0x1f

      if (op_str == 'jr') {
        dependencies["read"][rs] = "rs_val"
      }
    } else {
      op_str = opcodeMap[opcode];

      if (op_str == 'beq') {
        rs = (binary >>> 21) & 0x1f;
        var rt = (binary >>> 16) & 0x1f;
        dependencies["read"][rs] = "rs_val"
        dependencies["read"][rt] = "rt_val"
      }
    }
  }
  return dependencies;
}

function instructionDependencies(instruction) {
  var dependencies = {
    "read": new Map(),
    "write": new Map()
  };

  var r_ops = ['addu','subu','and','or','xor','sll','srl','sra'];
  var i_ops = ['addiu','andi','ori','xori'];

  if (instruction != undefined) {
    if (r_ops.indexOf(instruction["op_str"]) != -1) {
      dependencies["read"][instruction["rs"]] = "rs_val"
      dependencies["read"][instruction["rt"]] = "rt_val"
      dependencies["write"][instruction["rd"]] = "rd_val"
    }

    else if (i_ops.indexOf(instruction["op_str"]) != -1) {
      dependencies["read"][instruction["rs"]] = "rs_val"
      dependencies["write"][instruction["rt"]] = "rt_val"
    }
  }
  return dependencies;
}

function intersectKeys(xDeps, yDeps) {
  var x = Array.from(xDeps.keys());
  var y = Array.from(yDeps.keys());
  return x.filter(value => -1 !== y.indexOf(value));
}

export function solution(latches, registers, memory, globals) {
  var EA = ["addu","subu","and","or","nor","xor","sll","srl","sra","addiu","andi","ori","xori"]
  var MA = ["j","jal","jr","beq","lb","lh","lw","lui","sb","sh","sw"];

  /* ====== Check for individual stage dependencies (for later use) ======== */

  var idDependencies, exDependencies, memDependencies, wbDependencies;
  if (latches.if_id != undefined) {
    idDependencies = binaryDependencies(latches.if_id);
  }

  if (latches.id_ex != undefined) {
    exDependencies = instructionDependencies(latches.id_ex["instruction"]);
  }

  if (latches.ex_mem != undefined) {
    memDependencies = instructionDependencies(latches.ex_mem["instruction"]);
  }

  if (latches.mem_wb != undefined) {
    wbDependencies  = instructionDependencies(latches.mem_wb["instruction"]);
  }

  /* ====== Find overlaps between stages for data dependencies ======== */
  var idExDependencies  = [];
  var idMemDependencies = [];
  var idWbDependencies  = [];
  var exMemDependencies = [];
  var exWbDependencies  = [];
  if (idDependencies != undefined && exDependencies != undefined) {
    idExDependencies = intersectKeys(idDependencies["read"], exDependencies["write"])
  }

  if (idDependencies != undefined && memDependencies != undefined) {
    idMemDependencies = intersectKeys(idDependencies["read"], memDependencies["write"])
  }

  if (idDependencies != undefined && wbDependencies != undefined) {
    idWbDependencies = intersectKeys(idDependencies["read"], wbDependencies["write"])
  }

  if (exDependencies != undefined && memDependencies != undefined) {
    exMemDependencies = intersectKeys(exDependencies["read"], memDependencies["write"])
  }

  if (exDependencies != undefined && wbDependencies != undefined) {
    exWbDependencies = intersectKeys(exDependencies["read"], wbDependencies["write"])
  }

  WB(latches, registers, memory, globals);
  latches.mem_wb = undefined;

  MEM(latches, registers, memory, globals);
  latches.ex_mem = undefined;

  /* ====== For ER commands, data hazards are checked in MEM stages ======== */
  var dependency;
  var dependencyLocation;
  if (exMemDependencies.length != 0) {
    if (EA.indexOf(latches.mem["instruction"]["op_str"])) {
      // if ER in EX and EA in MEM, we forward from MEM -> EX
      dependency = exMemDependencies[0];
      dependencyLocation = memDependencies["write"][dependency];
      latches.id_ex[dependencyLocation] = dependency;

      EX(latches, registers, memory, globals);
    } else {
      return; // if ER in EX and MA in MEM, we stall
    }
  }

  if (exWbDependencies.length != 0) {
    // if ER in EX and EA/MA in WB, we always forward from WB -> EX
    dependency = exWbDependencies[0];
    dependencyLocation = wbDependencies["write"][dependency];
    latches.id_ex[dependencyLocation] = dependency;

    EX(latches, registers, memory, globals);
  }

  if (exMemDependencies.length == 0 && exWbDependencies.length == 0)  {
    EX(latches, registers, memory, globals);
    latches.id_ex = undefined;
  }

  /* ======= For DR commands, data hazards are checked in ID stages ======== */
  if (idExDependencies.length != 0) {
    return; // if DR in ID and EA/MA in EX, we must always stall
  }

  if (idMemDependencies.length != 0) {
    if (EA.indexOf(latches.ex_mem["instruction"]["op_str"])) {
      // if DR in ID and EA in MEM, we forward from MEM -> ID
      dependency = idMemDependencies[0];
      dependencyLocation = memDependencies["write"][dependency];
      latches.if_id[dependencyLocation] = dependency;

      ID(latches, registers, memory, globals);
    } else {
      return; // if DR in ID and MA in MEM, we stall
    }
  }

  if (idWbDependencies.length != 0) {
    // if DR in ID and EA/MA in WB, we always forward from WB -> ID
    dependency = idWbDependencies[0];
    dependencyLocation = wbDependencies["write"][dependency];
    latches.if_id[dependencyLocation] = dependency;

    ID(latches, registers, memory, globals);
  }

  if (idExDependencies.length == 0 && idMemDependencies.length == 0 &&
    idWbDependencies.length == 0)  {
    ID(latches, registers, memory, globals);
    latches.if_id = undefined;
  }

  if (!latches.term_if) {
    IF(latches, registers, memory, globals);
  }
}

var functMap = {
  0x21: "addu",
  0x23: "subu",
  0x24: "and",
  0x25: "or",
  0x27: "nor",
  0x26: "xor",
  0x00: "sll",
  0x02: "srl",
  0x03: "sra",
  0x08: "jr",
};

var opcodeMap = {
  0x09: "addiu",
  0x0c: "andi",
  0x0d: "ori",
  0x0e: "xori",
  0x20: "lb",
  0x21: "lh",
  0x23: "lw",
  0x0f: "lui",
  0x28: "sb",
  0x29: "sh",
  0x2b: "sw",
  0x04: "beq",
};

var nameToRegisterMap = {
  "$zero" : 0x0,
  "$at" : 0x1,
  "$v0" : 0x2,
  "$v1" : 0x3,
  "$a0" : 0x4,
  "$a1" : 0x5,
  "$a2" : 0x6,
  "$a3" : 0x7,
  "$t0" : 0x8,
  "$t1" : 0x9,
  "$t2" : 0xa,
  "$t3" : 0xb,
  "$t4" : 0xc,
  "$t5" : 0xd,
  "$t6" : 0xe,
  "$t7" : 0xf,
  "$s0" : 0x10,
  "$s1" : 0x11,
  "$s2" : 0x12,
  "$s3" : 0x13,
  "$s4" : 0x14,
  "$s5" : 0x15,
  "$s6" : 0x16,
  "$s7" : 0x17,
  "$t8" : 0x18,
  "$t9" : 0x19,
  "$k0" : 0x1a,
  "$k1" : 0x1b,
  "$gp" : 0x1c,
  "$sp" : 0x1d,
  "$fp" : 0x1e,
  "$ra" : 0x1f,
  "$pc" : 0x20
};
